<template>
  <info-card :title="$t('Type')">
    <div class="mt-n5">
      <v-checkbox
        v-for="family in allFamilies"
        :key="family.id"
        :label="family.filterName"
        :value="family.filterName"
        :class="family.slug"
        v-model="searchParams.selectedFamilies"
        hide-details
        multiple
        @change="onChangeFamily"
      >
        <template
          v-slot:append
          v-if="family.slug === 'e-liquid-shake-vape'">
          <div :class="family.slug">
            <v-checkbox
              v-for="(volume, i) in shakeAndVapeVolumes"
              :key="i"
              v-model="searchParams.selectedVolumes"
              :label="volume"
              :value="volume"
              class="ml-5"
              multiple
              hide-details
              @change="onChangeVolume" />
          </div>
        </template>
      </v-checkbox>
    </div>
  </info-card>
</template>

<script>
import InfoCard from '@/components/InfoCard'
import tagService from '@/services/tags'
import camelcaseKeys from 'camelcase-keys'
export default {
  name: 'FamilyFilter',
  components: {
    InfoCard
  },
  data: () => ({
    allFamilies: [],
    allFamiliesChecked: false,
    familyInput: '',
    searchParams: {
      selectedFamilies: [],
      selectedVolumes: []
    },
    shakeAndVapeVolumes: ['50 ml', '100 ml']
  }),

  computed: {
    checkedAllFamilies () {
      return this.searchParams.selectedFamilies.length === this.allFamilies.length
    },
    checkedSomeFamily () {
      return this.searchParams.selectedFamilies.length > 0
    }
  },

  mounted () {
    const conditions = {'Tags.slug IN': ['aroma', 'e-liquid-nicsalt', 'e-liquid-shake-vape', 'e-liquid-nicotine']}
    tagService.allByType('family', JSON.stringify(conditions))
      .then(data => {
        this.allFamilies = camelcaseKeys(data.data.tags, {deep: true})
      })
      .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
  },
  methods: {
    onChangeFamily () {
      const family = this.allFamilies.find(family => family.slug === 'e-liquid-shake-vape')
      if (!this.searchParams.selectedFamilies.includes(family.filterName)) {
        this.searchParams.selectedVolumes = []
      }
      this.$emit('change', this.searchParams)
    },
    onChangeVolume () {
      const family = this.allFamilies.find(family => family.slug === 'e-liquid-shake-vape')
      if (this.searchParams.selectedVolumes.length && !this.searchParams.selectedFamilies.includes(family.filterName)) {
        this.searchParams.selectedFamilies.push(family.filterName)
      }

      this.$emit('change', this.searchParams)
    },
    toggleFamilies () {
      this.$nextTick(() => {
        if (this.checkedAllFamilies) {
          this.searchParams.selectedFamilies = []
        } else {
          this.searchParams.selectedFamilies = this.allFamilies.map(family => family.name)
        }
      })
    },
    closeSelect () {
      this.$refs.selectType.blur()
    },
    reset () {
      this.searchParams.selectedFamilies = []
      this.searchParams.selectedVolumes = []
      this.$emit('change', this.searchParams)
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-input.e-liquid-shake-vape {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/vapevault/filters/FamilyFilter.vue